import { TriggerPoint } from "pages/survey/surveyService";
import { useEffect, useState } from "react";

export const useExitIntentHandler = (exitSurveySessionkey: string, isSurveyDisplayableStepcode: boolean) => {
  const [exitIntent, setExitIntent] = useState(false);
  const [triggerPoint, setTriggerPoint] = useState<TriggerPoint | null>(null);

  const checkIsSurveyDisplayed = () => {
    return sessionStorage.getItem(exitSurveySessionkey) === "true";
  };

  // Handle exit intent on mouse leaving the viewport
  useEffect(() => {
    const handleMouseOut = (event: MouseEvent) => {
      if (checkIsSurveyDisplayed()) {
        return;
      }

      if (event.clientY <= 10 && event.relatedTarget === null && isSurveyDisplayableStepcode) {
        setTriggerPoint(TriggerPoint.MouseOut);
        setExitIntent(true);
      }
    };

    document.addEventListener("mouseout", handleMouseOut);
    return () => document.removeEventListener("mouseout", handleMouseOut);
  }, [isSurveyDisplayableStepcode]);

  // Handle exit intent on browser back button click
  useEffect(() => {
    if (checkIsSurveyDisplayed()) {
      return;
    }

    // adds a fake entry to browser history to block back button navigation one time
    globalThis.history.pushState(null, "", globalThis.location.href);

    const handlePopState = () => {
      setTriggerPoint(TriggerPoint.BrowserBack);
      setExitIntent(true);
    };

    globalThis.addEventListener("popstate", handlePopState);

    return () => globalThis.removeEventListener("popstate", handlePopState);
  }, [isSurveyDisplayableStepcode]);

  return { exitIntent, triggerPoint };
};
